import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CardTable from "components/CardTable/CardTable";
import RegularButton from "components/CustomButtons/Button";
import { ModalV2 } from "components/Modal/ModalV2";

import AddIcon from "@material-ui/icons/Add";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";

import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { useValidateReload } from "hooks/useValidateReload";

import { columns } from "./columns";
import { mainTagsColumns } from "./mainColumnTags";
import { UnitsInputs } from "./UnitsInputs";
import { FormTags } from "./FormTags";
import { tagsSelector, unitsSelector } from "./selector";
import { getNfcTags } from "redux/actions/nfcTags/nfcTagsAction";

import {
  toggleUnitsView,
  getUnitsVersions
} from "redux/actions/unitsSection/unitsAction";


export const UnitsPage = () => {
  const tableKeys = {
    units: "unitsConfig",
    tags: "unitTagsConfig",
  };
  const dispatch = useDispatch();
  const unitsConfig = useSelector(unitsSelector);
  const unitTags = useSelector(tagsSelector);
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const { nfcTags } = useSelector(({ nfcTags }) => nfcTags);
  const { isTagsView, versions } = useSelector(
    ({ unitsReducer }) => unitsReducer
  );
  const { buildTableConfig } = useSearch();
  const [open, setOpen] = useToggle();

  const loadings = [
    "loadingUnits",
    "loadingTags",
    "loadingUnitsTransfer",
    "loadingConfigEdit",
    "loadingUpdateFlowmeter",
  ];
  useValidateReload(loadings)

  useEffect(() => {
    if(!configTables?.[tableKeys.units]) {
      buildTableConfig(tableKeys.units);
      buildTableConfig(tableKeys.tags)
    }
    versions.length === 0 && dispatch(getUnitsVersions());
    nfcTags.length === 0 && dispatch(getNfcTags());
  }, []);
  return (
    <>
      <CardTable
        hasHeader
        title={isTagsView ? "Etiquetas" : "Unidades a Sincronizar"}
        icon={isTagsView ? <LocalOfferIcon /> : <LocalShippingIcon />}
        columns={isTagsView ? mainTagsColumns : columns}
        data={isTagsView ? unitTags : unitsConfig}
        blockBtn
        hasControl
        isLoading={isLoadingComp?.loadingUnits}
        tableContent={<UnitsInputs tableKey={tableKeys} />}
        tableKey={isTagsView ? tableKeys.tags : tableKeys.units}
        controls={
          <>
            {isTagsView && (
              <RegularButton
                justIcon
                round
                size="sm"
                color="info"
                onClick={setOpen}
                tooltip="Agregar Etiqueta"
              >
                <AddIcon />
              </RegularButton>
            )}
            <RegularButton
              size="sm"
              color="info"
              onClick={() => dispatch(toggleUnitsView())}
            >
              {/* {isTagsView ? (
                <LocalShippingIcon style={{ margin: 0 }} />
              ) : (
                <LocalOfferIcon style={{ margin: 0 }} />
              )} */}
              {isTagsView ? "Cambiar a Unidades" : "Cambiar a Etiquetas"}
            </RegularButton>
          </>
        }
      />
      <ModalV2 open={open} onClose={setOpen} title="Agregar Etiqueta">
        <FormTags onClose={setOpen} />
      </ModalV2>
    </>
  );
};
